export default "__VITE_ASSET__e5929478__"